// web-staking-estimator-frontend/src/hooks/useUIVisibility.js

/**
 * Hook to manage UI visibility logic based on app state.
 * Returns computed visibility flags for different UI sections.
 */
export function useUIVisibility({
  selectedPoint,
  serviceOk,
  memberOk,
  infraHints,
  requestInfo,
  isSearchingMap,
}) {
  const hasPin =
    Number.isFinite(selectedPoint?.x) &&
    Number.isFinite(selectedPoint?.y) &&
    Number.isFinite(selectedPoint?.wkid);

  const estimateVisible = hasPin && serviceOk && memberOk;
  
  const nearestNone = !!infraHints?.noneFound;
  
  const assistanceVisible = 
    !!requestInfo?.blocked || (!isSearchingMap && nearestNone);

  // Show global "Start over" when there's anything meaningful to clear
  const hasAnyInput =
    hasPin ||
    !!requestInfo?.svc_phase ||
    !!requestInfo?.svc_volts ||
    Number.isFinite(requestInfo?.svc_amps) ||
    !!requestInfo?.svc_ohug;

  return {
    hasPin,
    estimateVisible,
    nearestNone,
    assistanceVisible,
    hasAnyInput,
  };
}
